import ReceivePage from './ReceivePage';
export default ReceivePage;
